<!-- 新增线上月票类型接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
              "monthTicketConfigId": 1000002539,
              "ticketName": "wangj-多位多车",
              "price": 10,
              "parkCodeList": [
                "PR2VGT0N",
                "PR2VGT0M"
              ]
            },
            responseCode: {
                "data": {
                    "monthTicketConfigId": 529
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台修改线上月票类型",
                t_url: this.commonUrls.test + "monthTicketConfigEdit",
                p_url: this.commonUrls.prod + "monthTicketConfigEdit",
                precondition: "无",
                fitSystem: "云停车场,VEMS传统车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'String', info4: '月票类型ID' },
                        { info1: 'ticketName', info2: '是', info3: 'String', info4: '月票名称' },
                        { info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '适用车场编号列表' },
                        { info1: 'vipType', info2: '否', info3: 'Integer', info4: 'VIP类型（2本地VIP，3外部VIP），默认为2，外部VIP需要手动开闸' },
                        { info1: 'financialParkCode', info2: '否', info3: 'Integer', info4: '财务主体车场编号，默认取适用车场第一个' },
                        { info1: 'channelInfoList', info2: '否', info3: 'Integer', info4: '适用通道列表' },
                      { info1: 'maxSellLimit', info2: '否', info3: 'Integer', info4: '最大销售数量限制，0无限，1有限。默认0' },
                      { info1: 'maxSellNum', info2: '否', info3: 'Integer', info4: '最大销售数量，maxSellLimit=1时必填' },
                      { info1: 'renewMethod', info2: '否', info3: 'Integer', info4: '续费方式，对内月票才有，0自然月，1自定义（允许车主自定义选择续费时间，价格按照天数去计算。如月票单价300元，每天则为10元。）默认0' },
                      { info1: 'price', info2: '是', info3: 'Decimal', info4: '单价' },
                      { info1: 'validTo', info2: '否', info3: 'Date', info4: '有效期至 yyyyMMddHHmmss' },
                      { info1: 'remark', info2: '否', info3: 'String', info4: '月票简介' },
                      { info1: 'isOnlineOpen', info2: '否', info3: 'Integer', info4: '是否允许移动端开票 0：否 1：是 默认0' },
                      { info1: 'monthTicketContinueDiscountList', info2: '否', info3: 'JSONArray', info4: '连续续费优惠配置' },
                      { info1: 'certifiRuleId', info2: '否', info3: 'Long', info4: '月票凭证ID' },
                      { info1: 'renewFormerDays', info2: '否', info3: 'Integer', info4: '允许车主购买该月票时，向前续费相应的天数。0表示不允许向前续费。默认0' },
                      { info1: 'inviteCarTotal', info2: '否', info3: 'Integer', info4: '允许授权访客车牌数' },
                      { info1: 'isDynamicMode', info2: '否', info3: 'Integer', info4: '是否多位多车（0否，1是），“开启多位多车”后，可限制VIP车主的VIP车辆数，如可用车位数为2，车主绑定VIP车辆为3，则前2辆进场的车辆可视为VIP车辆，第三辆车则被视为临时车；若无勾选，系统将把VIP车主绑定的所有车牌对应车辆均视为VIP车辆。默认0' },
                      { info1: 'autoSwitchVip', info2: '否', info3: 'Integer', info4: '是否自动切换多位多车场内临时车转vip(0否,1是)。isDynamicMode=1时有效，默认0' },
                      { info1: 'dynamicFullLimit', info2: '否', info3: 'Integer', info4: '是否多位多车满位，同组在场车无法进入（0否，1是）。isDynamicMode=1时设置，默认0' },
                      { info1: 'openVipFullLimit', info2: '否', info3: 'Integer', info4: '是否开启vip满位控制,（0否,1是），满位控制指的是当停车场该月票在场车辆达到限制数目后，对后续的该月票类型进行限制入场，限制入场的车辆需手动确认放行，放行后的车辆依旧是月票车辆。默认0' },
                      { info1: 'vipFullLimitValue', info2: '否', info3: 'Integer', info4: 'vip满位阈值' },
                      { info1: 'vipFullOpenModel', info2: '否', info3: 'Integer', info4: 'VIP满位放行模式（0有空位自动放行，无空位手动放行按VIP计费 1有空位自动放行，无空位手动放行按临时车计费 2无空位自动放行，按临时车计费）。默认0' },
                      { info1: 'isDatePrivilege', info2: '否', info3: 'Integer', info4: '月票生效的日期，是否区分日期（0不区分，1区分）。默认0' },
                      { info1: 'isTimePrivilege', info2: '否', info3: 'Integer', info4: '月票生效的时段，是否区分时间段（0不区分，1区分）。默认0' },
                      { info1: 'privilegedateList', info2: '否', info3: 'String', info4: 'VIP有效日期，isDatePrivilege=1时必填,格式：yyyy-MM-dd，使用‘,’分割。例：“2019-01-01,2019-01-02”' },
                      { info1: 'privilegeTimePeriod', info2: '否', info3: 'String', info4: 'VIP有权限时间段，isTimePrivilege=1时必填，格式mm:ss-mm:ss' },
                      { info1: 'isChargeGroupRelated', info2: '否', info3: 'Integer', info4: '是否关联收费组(0否,1是，默认为否)' },
                      { info1: 'chargeGroupCode', info2: '否', info3: 'String', info4: '收费组编号' },
                      { info1: 'isSupportOffLine', info2: '否', info3: 'String', info4: '是否支持离线月票0否，1是' },
                ]
                },{
                    titleName: 'monthTicketContinueDiscountList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'sort', info2: '否', info3: 'Integer', info4: '优惠顺序' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'continuDiscountType', info2: '否', info3: 'Integer', info4: '连续优惠类型,0:折扣优惠,1:金额优惠' },
                        { info1: 'continuMonth', info2: '否', info3: 'Integer', info4: '连续月份' },
                        { info1: 'discount', info2: '否', info3: 'Integer', info4: '折扣 1:1折 2：2折' },
                        { info1: 'price', info2: '否', info3: 'BigDecimal', info4: '月票单价' },
                        { info1: 'amountMoney', info2: '否', info3: 'BigDecimal', info4: '总金额' },
                        { info1: 'discountMoney', info2: '否', info3: 'BigDecimal', info4: '优惠金额,当type为1时必填' },
                        ]
                },{
                    titleName: 'channelInfoList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '车场编码' },
                        { info1: 'parkName', info2: '否', info3: 'String', info4: '停车场名称' },
                        { info1: 'channelId', info2: '否', info3: 'Long', info4: '通道id' },
                        { info1: 'name', info2: '否', info3: 'Long', info4: '通道名称' },
                        { info1: 'entranceType', info2: '否', info3: 'Integer', info4: '通道类型 1：进口 2：出口' },
                        ]
                }] ,
              R_params: [{
                titleName: null,
                tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                td: [
                  { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型id' },
                ]
              }],
              codeStatus: [{
                titleName: null,
                tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
              }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/monthTicketConfigEdit.vue